
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class WorkOrderDialog extends _Ext.MFGTransDialog<WorkOrderRow, any> {
        protected getFormKey() { return WorkOrderForm.formKey; }
        protected getIdProperty() { return WorkOrderRow.idProperty; }
        protected getLocalTextPrefix() { return WorkOrderRow.localTextPrefix; }
        protected getNameProperty() { return WorkOrderRow.nameProperty; }
        protected getService() { return WorkOrderService.baseUrl; }
        protected getDeletePermission() { return WorkOrderRow.deletePermission; }
        protected getInsertPermission() { return WorkOrderRow.insertPermission; }
        protected getUpdatePermission() { return WorkOrderRow.updatePermission; }

        public form = new WorkOrderForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 200;
            q.initMFGItemEditor(this, this.form.ItemDetails, Config);
            q.initMFGItemEditor(this, this.form.SelectDetails, Config);
            q.hideEditorLabel(this.form.SelectDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorToolbar(this.form.ItemDetails);
            q.HideCategoryLable(this.element);
            q.setTextRightAlign(this.form.NoofBags);
            q.setTextRightAlign(this.form.Pieces);
            q.setGridEditorHeight(this.form.SelectDetails, 200);
            q.setGridEditorHeight(this.form.ItemDetails, 200);
            
            this.form.NoofBags.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.DepartmentId.value)) {


                    if (this.form.NoofBags.value > 0) {
                        var selectedrow = this.form.SelectDetails.currentrow;

                        if (selectedrow == undefined) {
                            Q.alert('No item selected');
                            this.form.NoofBags.value = 0;
                            return;
                        } else if (this.form.NoofBags.value > this.form.Pieces.value) {
                            Q.alert('Invalid No of Bags Entered');
                            this.form.NoofBags.value = 0;
                            return;
                        } else {
                            var olditems = this.form.ItemDetails.getItems().filter(a => a.Line_No == selectedrow.Line_No);
                            if (olditems.length < this.form.Pieces.value) {
                                this.form.ItemDetails.setData(selectedrow, this.form.NoofBags.value);
                                this.form.NoofBags.value = 0;
                            }
                            else {
                                Q.alert('Invalid No of Bags Entered');
                                this.form.NoofBags.value = 0;
                                return;
                            }

                        }
                    }
                }
                else {
                    q.alert("Enter Workshop", "Please select workshop before proceeding",false,2999);
                    this.form.NoofBags.value = 0;
                    this.form.DepartmentId.element.focus();
                    return;
                }
            });
            this.form.SelectDetails.view.onDataChanged.subscribe(function () {
                var q = 1;
            });
        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                items[i].DepartmentId = parseInt(this.form.DepartmentId.value);
                if (items[i].EmployeeId == 0) {
                    Q.alert('Worker not valid');
                    return false;
                }
            }
            return true;
        }
    }
}